import bindAllOfThis from 'src/utils/BindThisHelper';
import { TiledGameObject } from 'src/games/shared/phaserHelpers/HandyTypes';
import { Helper } from '../objects/Helper';
import { EndGameScene } from './EndGameScene';

export class MainScene extends Phaser.Scene {
    gameWidth: number;
    gameHeight: number;
    map: Phaser.Tilemaps.Tilemap;

    line: Phaser.GameObjects.Zone;
    helpers: Helper[];

    constructor() {
        super({
            key: "MainScene"
        });
        bindAllOfThis(this, MainScene.prototype);
    }

    preload(): void {
        this.load.tilemapTiledJSON('map', require("/src/assets/qci/maps/find_helpers.json"));
        this.load.image('background', require('/src/assets/qci/backgrounds/pks_background.png'));
        this.load.atlas("assets", require("src/assets/qci/atlas/gameFindHelpers.png"), require("src/assets/qci/atlas/gameFindHelpers.json"));
    }

    initialize(): void {
        this.gameWidth = this.textures.game.config.width as number;
        this.gameHeight = this.textures.game.config.height as number;
        this.map = this.make.tilemap({ key: 'map' });
        this.helpers = [];
    }

    create(): void {
        this.initialize();
        var background = this.add.image(0, 0, "background").setOrigin(0).setDepth(0);
        this.createLineDropzone();
        this.createHelpers();
        this.registerEvents();
        var people = this.add.image(0, 0, "assets", "people").setOrigin(0);
    }

    createLineDropzone() {
        var ob = this.map.getObjectLayer("Scene").objects.find((ob: TiledGameObject) => ob.name === "line") as TiledGameObject;
        this.line = this.add.zone(ob.x + ob.width / 2, ob.y + ob.height / 2, ob.width, ob.height);
        this.line.setRectangleDropZone(ob.width, ob.height);

        this.add.graphics()
            .strokeRect(this.line.x - this.line.input.hitArea.width / 2, this.line.y - this.line.input.hitArea.height / 2, this.line.input.hitArea.width, this.line.input.hitArea.height);
    }

    createHelpers() {
        var id = 0;
        this.map.getObjectLayer("Helpers").objects.forEach((ob: TiledGameObject) => {
            var helper = new Helper(this, ob, id++);
            var spot = this.map.getObjectLayer("Zones").objects.find((ob: TiledGameObject) => ob.properties[0].value === helper.id) as TiledGameObject;
            helper.setLinePosition(spot);
            this.helpers.push(helper);
        });
    }

    registerEvents(): void {
        this.input.dragDistanceThreshold = 10;

        this.input.on('dragstart', (pointer: Phaser.Input.Pointer, helper: Helper) => {
            this.children.bringToTop(helper);
        });

        this.input.on('drag', (pointer: Phaser.Input.Pointer, helper: Helper, dragX: number, dragY: number) => {
            helper.x = dragX;
            helper.y = dragY;
        });

        this.input.on('dragend', (pointer: Phaser.Input.Pointer, helper: Helper, dropped: boolean) => {
            if (!dropped) {
                // Put back
                helper.x = helper.input.dragStartX;
                helper.y = helper.input.dragStartY;
            }
        });

        this.input.on('drop', (pointer: Phaser.Input.Pointer, helper: Helper, zone) => {
            this.drop(helper);
        });
    }

    drop(helper: Helper) {
        this.children.bringToTop(helper);
        helper.isInLine = true;
        helper.putInLine();

        this.isGameOver();
    }

    isGameOver(): boolean {
        var helper: Helper;

        for (helper of this.helpers) {
            if (!helper.isInLine) {
                return false;
            }
        }

        this.input.enabled = false;

        // Wait a second and then end the game
        setTimeout(() => {
            this.scene.add("EndGameScene", EndGameScene, true);
            this.scene.remove(this);
        }, 1000);

        return true;
    }
}



// WEBPACK FOOTER //
// ./src/games/FindHelpersGame/scenes/MainScene.ts